import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api, { apiErr } from "@/lib/api";
import { inr, fdt } from "@/lib/format";
import { toast } from "sonner";

// Refunds the gateway has not confirmed. Not counted as money out until verified.
export function PendingRefunds() {
  const qc = useQueryClient();
  const { data = [] } = useQuery({ queryKey: ["refunds-pending"], queryFn: async () => (await api.get("/refunds?status=pending")).data });
  const resolve = useMutation({
    mutationFn: ({ id, outcome, note }) => api.post(`/refunds/${id}/resolve`, { outcome, note }),
    onSuccess: () => { ["refunds-pending", "payments", "dashboard"].forEach((k) => qc.invalidateQueries({ queryKey: [k] })); toast.success("Refund updated"); },
    onError: (e) => toast.error(apiErr(e)),
  });
  const ask = (id, outcome) => {
    const note = window.prompt(outcome === "completed" ? "What confirms the refund succeeded? (e.g. gateway refund id)" : "What confirms the refund failed?");
    if (note && note.trim()) resolve.mutate({ id, outcome, note });
  };
  if (!data.length) return null;
  return (
    <div className="mb-6 rounded-xl border border-amber-200 bg-amber-50 p-4" data-testid="pending-refunds">
      <div className="text-sm font-semibold text-amber-900">Pending refunds ({data.length}) — not yet counted as money out</div>
      <div className="mt-2 divide-y divide-amber-100">
        {data.map((r) => (
          <div key={r.id} className="flex flex-wrap items-center justify-between gap-2 py-2 text-xs" data-testid={`pending-refund-${r.id}`}>
            <span className="text-amber-900">{inr(r.amount)} · {fdt(r.created_at)}{r.last_error ? ` · ${r.last_error}` : ""}</span>
            <span className="flex gap-2">
              <button onClick={() => ask(r.id, "completed")} data-testid={`refund-confirm-${r.id}`} className="rounded border border-emerald-300 bg-white px-2 py-1 font-semibold text-emerald-700">Mark completed</button>
              <button onClick={() => ask(r.id, "failed")} data-testid={`refund-fail-${r.id}`} className="rounded border border-rose-300 bg-white px-2 py-1 font-semibold text-rose-700">Mark failed</button>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
